import { MutationTree } from 'vuex';
import { StatisticState, ViberDetailItem, ViberGroupItem } from './types';

export const mutations: MutationTree<StatisticState> = {
  setViberStatisticDetail: (state, data: ViberDetailItem[]) => state.viberStatisticDetail = data,
  pushViberStatisticDetail: (state, data: ViberDetailItem[]) => state.viberStatisticDetail = state.viberStatisticDetail.concat(data),
  setViberStatisticDetailFlag: (state, flag: string) => state.viberStatisticDetailFlag = flag,
  setViberMessagesCount: (state, count: number) => state.viberStatisticGroupMessageCount = count,
  setViberStatisticGroup: (state, data: ViberGroupItem[]) => state.viberStatisticGroup = data
};